/*!
 * NAYA STORE — Conversion Layer v2
 * Countdown · Live viewers · Reviews carousel · Recent-purchase popup
 */
(function () {
  'use strict';

  const FLASH_DURATION  = 15 * 60;
  const FLASH_KEY       = 'naya_flash_end';
  const PURCHASES = [
    { name: 'Sarah M.',  city: 'London',     emoji: '🛍️', ago: '2 min ago'  },
    { name: 'James T.',  city: 'Manchester', emoji: '✨',  ago: '5 min ago'  },
    { name: 'Emma R.',   city: 'Birmingham', emoji: '🎁',  ago: '8 min ago'  },
    { name: 'Noah K.',   city: 'Edinburgh',  emoji: '🛒',  ago: '12 min ago' },
    { name: 'Olivia P.', city: 'Bristol',    emoji: '💫',  ago: '16 min ago' },
    { name: 'Liam S.',   city: 'Leeds',      emoji: '✅',  ago: '20 min ago' },
    { name: 'Isla W.',   city: 'Glasgow',    emoji: '🌟',  ago: '24 min ago' },
  ];

  /* ── Shared countdown engine (drives ALL [data-ncv-countdown] elements) ── */
  function initCountdowns() {
    const els = document.querySelectorAll('[data-ncv-countdown]');
    if (!els.length) return;
    const now = () => Math.floor(Date.now() / 1000);
    let end = parseInt(sessionStorage.getItem(FLASH_KEY) || '0', 10);
    if (end <= now()) { end = now() + FLASH_DURATION; sessionStorage.setItem(FLASH_KEY, end); }
    const fmt = s => `${String(Math.floor(s/60)).padStart(2,'0')}:${String(s%60).padStart(2,'0')}`;
    const tick = () => {
      const rem = Math.max(0, end - now());
      els.forEach(el => (el.textContent = fmt(rem)));
      if (rem === 0) { end = now() + FLASH_DURATION; sessionStorage.setItem(FLASH_KEY, end); }
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ── Live viewers (all [data-ncv-viewers] elements) ── */
  function initViewers() {
    const els = document.querySelectorAll('[data-ncv-viewers]');
    if (!els.length) return;
    let n = Math.floor(Math.random() * 22) + 12;
    const up = () => els.forEach(el => (el.textContent = n));
    up();
    const drift = () => {
      n = Math.max(8, Math.min(55, n + (Math.random() > 0.45 ? 1 : -1)));
      up();
      setTimeout(drift, 7000 + Math.random() * 9000);
    };
    setTimeout(drift, 10000 + Math.random() * 5000);
  }

  /* ── Reviews carousel ── */
  function initCarousel() {
    const carousels = document.querySelectorAll('#ncv-reviews, .ncv-reviews-carousel');
    carousels.forEach(el => {
      const items = el.querySelectorAll('.ncv-rc__item');
      if (items.length < 2) return;
      let cur = 0;
      const go = (dir) => {
        items[cur].classList.remove('is-active');
        cur = (cur + dir + items.length) % items.length;
        items[cur].classList.add('is-active');
      };
      el.querySelector('[data-rc-next]')?.addEventListener('click', () => go(1));
      el.querySelector('[data-rc-prev]')?.addEventListener('click', () => go(-1));
      // Auto-advance every 6 seconds
      setInterval(() => go(1), 6000);
    });
  }

  /* ── Recent purchase popup ── */
  function initPopup() {
    if (!document.querySelector('.product, product-info')) return;
    const box = document.createElement('div');
    box.className = 'ncv-popup';
    box.innerHTML = `
      <span class="ncv-popup__emoji"></span>
      <span class="ncv-popup__text">
        <strong class="j-name"></strong> from <span class="j-city"></span> just purchased this
        <span class="ncv-popup__ago j-ago"></span>
      </span>`;
    document.body.appendChild(box);
    const emoji = box.querySelector('.ncv-popup__emoji');
    const name  = box.querySelector('.j-name');
    const city  = box.querySelector('.j-city');
    const ago   = box.querySelector('.j-ago');
    let idx = 0;
    const show = () => {
      const p = PURCHASES[idx++ % PURCHASES.length];
      emoji.textContent = p.emoji; name.textContent = p.name;
      city.textContent = p.city; ago.textContent = p.ago;
      box.classList.add('is-on');
      setTimeout(() => {
        box.classList.remove('is-on');
        setTimeout(show, 13000 + Math.random() * 9000);
      }, 4800);
    };
    setTimeout(show, 8000 + Math.random() * 4000);
  }

  const boot = () => { initCountdowns(); initViewers(); initCarousel(); initPopup(); };
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot)
    : boot();
})();
